
<div>
    <h1 class="mb-4 sm:mb-5 md:mb-6 font-bold text-2xl sm:text-3xl md:text-3xl" *ngIf="title()">{{title()}}</h1>

    <div *ngIf="showFiltering()" class="mb-6 sm:mb-7 md:mb-8">
      <hypenation-tickets-filtering-options
        [eventsTypes]="eventsTypes()"
        (selectEventCategory)="onSelectEventCategory($event)"
        (clearFilter)="onClearFilter()"
      ></hypenation-tickets-filtering-options>
    </div>

    <div
    *ngIf="!loading()"
    class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 sm:gap-5 md:gap-6"
    >
    @for (event of events(); track event.uid) {
      @if (cardTemplate) {
        <ng-container
          [ngTemplateOutlet]="cardTemplate"
          [ngTemplateOutletContext]="{ $implicit: event }"
        ></ng-container>
      } @else {
        <hypenation-tickets-event-card
          [routerLink]="
            '/tickets/' + event.slug + '/' + event.uid + '/' + event.eventType.uid
          "
          [event]="event"
        ></hypenation-tickets-event-card>
      }
    }
    </div>

    <div *ngIf="loading()">
    <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 sm:gap-5 md:gap-6">
      @for (item of [1,2,3,4,5,6,7,8]; track $index) {
      <hypenation-tickets-event-skeleton></hypenation-tickets-event-skeleton>

      }
    </div>
    </div>

    @if (loadMode() === 'button' && hasMore()) {
      <div class="flex justify-center my-6 sm:my-8">
        <button
          type="button"
          class="inline-flex items-center gap-2 px-6 py-2.5 rounded-full border border-gray-300 bg-white hover:bg-gray-50 text-sm sm:text-base font-medium text-gray-800 shadow-sm transition-colors disabled:opacity-60 disabled:cursor-not-allowed"
          [disabled]="loadingMore()"
          (click)="onLoadMoreClick()"
        >
          @if (loadingMore()) {
            <nz-spin nzSimple [nzSize]="'small'"></nz-spin>
            <span>Loading...</span>
          } @else {
            <span>Load more</span>
          }
        </button>
      </div>
    }

    @if (loadMode() === 'auto' && hasMore()) {
      <div
        hypenationInfiniteScroll
        [hasMore]="hasMore()"
        [loadingMore]="loadingMore()"
        (scrollEnd)="onSentinelIntersect()"
        class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 sm:gap-5 md:gap-6 mt-4 sm:mt-5 md:mt-6"
      >
        @for (item of [1,2,3,4]; track $index) {
          <hypenation-tickets-event-skeleton></hypenation-tickets-event-skeleton>
        }
      </div>
    }
</div>
